<div class="page-wrap mt-5">
  <div class="network-header d-flex align-items-center justify-content-between">
    <h4 class="mb-0">Followers</h4>
    <div class="search-box">
      <!-- reserved for future search -->
    </div>
  </div>

  <div class="user-grid" *ngIf="users?.length; else emptyState">
    <div class="user-card" *ngFor="let u of users; let i = index" [style.animation-delay]="i * 0.05 + 's'">
      <div class="avatar-container">
        <div class="avatar" 
             [ngStyle]="{ 'background-image': 'url(' + ((u.photo || u.profilePhoto || u.profilePic) | userProfilePhoto) + '), url(assets/default-user.jpg)' }">
          <div class="avatar-overlay">
            <i class="fas fa-user"></i>
          </div>
        </div>
        <span class="online-indicator" *ngIf="u.isOnline"></span>
      </div>
      <div class="info">
        <div class="name" [title]="u.name || u.email">
          <span class="name-text">{{ u.name || (u.email | slice:0:22) || 'Unknown' }}</span>
          <span class="verified-badge" *ngIf="u.verified">
            <i class="fas fa-check-circle"></i>
          </span>
        </div>
        <div class="meta username" [title]="'@' + (u.userName || u.businessUserName || u.slug)">@{{ u.userName || u.businessUserName || u.slug || 'user' }}</div>
        <div class="meta bio" *ngIf="u.bio">{{ u.bio | slice:0:50 }}{{ u.bio.length > 50 ? '...' : '' }}</div>
        <div class="meta location" *ngIf="u.location">
          <i class="fas fa-map-marker-alt"></i>
          {{ u.location }}
        </div>
      </div>
      <!-- <div class="card-actions">
        <a class="action-btn view-btn" [routerLink]="['/', u.userName || u.businessUserName || u.slug || u._id]">
          <i class="fas fa-user"></i>
          <span>View</span>
        </a>
      </div> -->
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-users"></i>
      </div>
      <h3>No Followers Yet</h3>
      <p>When people follow you, they'll appear here.</p>
    </div>
  </ng-template>

  <nav class="pagination-nav mt-4" *ngIf="users?.length">
    <ul class="pagination">
      <li class="page-item" [class.disabled]="page <= 1 || loading">
        <a class="page-link" href="javascript:void(0)" (click)="prevPage()">
          <i class="fas fa-chevron-left"></i>
          Previous
        </a>
      </li>
      <li class="page-item active"><span class="page-link">{{ page }}</span></li>
      <li class="page-item" [class.disabled]="!canGoNext || loading">
        <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
          Next
          <i class="fas fa-chevron-right"></i>
        </a>
      </li>
    </ul>
  </nav>

  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</div>

